import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'dashboard' },
      meta: {
        auth: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        auth: true
      }
    },
    {
      path: '/projects/:id/detail',
      name: 'project-detail',
      component: () => import(/* webpackChunkName: "project_detail" */ '@/views/ProjectDetail.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/administrative-concept/:id',
      name: 'administrative-detail',
      component: () => import(/* webpackChunkName: "project_detail" */ '@/views/AdministrativeDetail.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/suppliers/:id/detail',
      name: 'supplier-detail',
      component: () => import(/* webpackChunkName: "supplier_detail" */ '@/views/SupplierDetail.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/administrative-concepts',
      name: 'administrative_concepts',
      component: () => import(/* webpackChunkName: "administrative_concepts" */ '@/views/AdministrativeConcepts.vue'),
      meta: {
        title: Vue.i18n.translate('strings.administrative_concepts', null),
        auth: {
          roles: ['Admin', 'Viewer'],
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'administrativeConceptsDetail',
        component: () => import(/* webpackChunkName: "administrative_concepts" */ '@/views/AdministrativeConcepts.vue')
      }]
    },
    {
      path: '/customers',
      name: 'customers',
      component: () => import(/* webpackChunkName: "customers" */ '@/views/Customers.vue'),
      meta: {
        title: Vue.i18n.translate('strings.customers', null),
        auth: {
          roles: ['Admin', 'Viewer'],
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'customersDetail',
        component: () => import(/* webpackChunkName: "customers" */ '@/views/Customers.vue')
      }]
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import(/* webpackChunkName: "projects" */ '@/views/Projects.vue'),
      meta: {
        title: Vue.i18n.translate('strings.projects', null),
        auth: {
          roles: ['Admin', 'Viewer'],
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'projectsDetail',
        component: () => import(/* webpackChunkName: "projects" */ '@/views/Projects.vue')
      }]
    },
    {
      path: '/concepts',
      name: 'concepts',
      component: () => import(/* webpackChunkName: "concepts" */ '@/views/Concepts.vue'),
      meta: {
        title: Vue.i18n.translate('strings.concepts', null),
        auth: {
          roles: ['Admin', 'Viewer'],
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'conceptsDetail',
        component: () => import(/* webpackChunkName: "concepts" */ '@/views/Concepts.vue')
      }]
    },
    {
      path: '/suppliers',
      name: 'suppliers',
      component: () => import(/* webpackChunkName: "suppliers" */ '@/views/Suppliers.vue'),
      meta: {
        title: Vue.i18n.translate('strings.suppliers', null),
        auth: {
          roles: ['Admin', 'Viewer'],
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'suppliersDetail',
        component: () => import(/* webpackChunkName: "suppliers" */ '@/views/Suppliers.vue')
      }]
    },
    // New Route
    {
      path: '/users',
      name: 'users',
      component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue'),
      meta: {
        title: Vue.i18n.translate('strings.users', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'userDetail',
        component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue')
      }]
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (login.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/AuthLogin.vue'),
      meta: {
        title: Vue.i18n.translate('login.login', null),
        auth: false
      }
    },
    {
      path: '/register',
      name: 'register',
      // route level code-splitting
      // this generates a separate chunk (register.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "register" */ '@/views/Auth/AuthRegister.vue'),
      meta: {
        title: Vue.i18n.translate('login.register', null),
        auth: false
      }
    },
    {
      path: '/password/reset',
      name: 'reset',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/Auth/AuthResetLink.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/password/reset/:token',
      name: 'reset.token',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/Auth/AuthResetForm.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/email/verify',
      name: 'verification.notice',
      props: true,
      component: () => import(/* webpackChunkName: "verification" */ '@/views/Auth/AuthVerify.vue'),
      meta: {
        title: Vue.i18n.translate('verification.title', null),
        auth: false
      }
    }
  ]
})

// It's required for VueAuth
Vue.router = router

export default router
